import { motion } from "framer-motion";

const HERO_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/k7zd921i_IMG_3882.png";

export default function Hero() {
  return (
    <section
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#FDFBF7] grain"
      data-testid="hero-section"
    >
      {/* Overline */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.7 }}
        className="pt-32 md:pt-40 px-6 md:px-10 max-w-[1440px] mx-auto"
      >
        <div className="flex items-center gap-3 text-[#0A0A0A]">
          <span className="w-8 h-px bg-[#0A0A0A]" />
          <span className="overline">
            A mirror photo booth studio · Weddings · Quinceañeras · Corporate · and more
          </span>
        </div>
      </motion.div>

      {/* SR-only H1 for a11y */}
      <h1 className="sr-only" data-testid="hero-title">
        Photo Booth Memories — Making Memories in Chicagoland
      </h1>

      {/* Two-column layout: picture (left) + reserve/stats (right) */}
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 mt-8 md:mt-14 pb-16 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        {/* LEFT: picture + paragraph beneath */}
        <div className="md:col-span-7">
          <motion.div
            initial={{ scale: 1.08, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-[620px] h-[58vh] md:h-[62vh] arched shadow-2xl bg-black"
            style={{
              backgroundImage: `url(${HERO_IMG})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            aria-hidden="true"
          />
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 md:mt-8 max-w-[620px] text-base md:text-lg leading-relaxed text-[#0A0A0A]"
            data-testid="hero-paragraph"
          >
            Don&apos;t just rent a booth — give your guests something to{" "}
            <em>remember</em>. A family-run mirror photo booth studio building
            keepsakes for weddings, quinces, and joyful gatherings across
            Chicagoland.
          </motion.p>
        </div>

        {/* RIGHT: Reserve CTA + stats */}
        <div className="md:col-span-5 md:pt-6 flex flex-col gap-10 md:gap-14">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-start gap-4"
          >
            <a
              href="#booking"
              className="group inline-flex items-center gap-3 pl-5 pr-2 py-2 rounded-full bg-[#0A0A0A] text-[#FDFBF7] hover:bg-[#FF5722] transition-colors"
              data-testid="hero-book-btn"
            >
              <span className="text-sm tracking-wide">Reserve your date</span>
              <span className="w-9 h-9 rounded-full bg-[#FDFBF7] text-[#0A0A0A] flex items-center justify-center group-hover:rotate-45 transition-transform">
                →
              </span>
            </a>
            <a
              href="#portfolio"
              className="text-sm underline underline-offset-4 hover:text-[#FF5722] transition-colors"
              data-testid="hero-view-work"
            >
              View the archive
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-3 gap-6 text-[#0A0A0A] max-w-md"
          >
            <div>
              <div className="font-serif text-4xl md:text-5xl leading-none">
                50+
              </div>
              <div className="overline mt-2 opacity-70">Events</div>
            </div>
            <div>
              <div className="font-serif text-4xl md:text-5xl leading-none">
                84k+
              </div>
              <div className="overline mt-2 opacity-70">Portraits</div>
            </div>
            <div>
              <div className="font-serif text-4xl md:text-5xl leading-none">
                4.9
              </div>
              <div className="overline mt-2 opacity-70">Rated</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
